/*
    Components
        - Components Interface
    Data
        - Auth Interface
*/

// Recover password
export interface Token {
    token: string
}

export interface LoginNav {
    loginNav: boolean
}

export interface Phone {
    phone: string | undefined
}

export enum ContactType {
    MOBILE = 'MOBILE',
    EMAIL = 'EMAIL',
    WHATSAPP = 'WHATSAPP',
    SMS = 'SMS',
    UNICO = 'UNICO',
}

export enum ContactTypeToReset {
    CELULAR = 'CELULAR',
    EMAIL = 'EMAIL',
    SMS = 'SMS',
}

export interface ContactList {
    mobile: Contact[]
    email: Contact[]
}
export interface Contact {
    id?: number
    contactType?: ContactType
    type?: ContactType
    value?: string
    principal?: boolean
    validated?: boolean
}

export interface DestinationTokenInterface {
    id: number
    tokenType: string
    label: string
}

export interface ChangePasswordInfoInput {
    username?: string
    token?: string
    newPassword?: string
}
export interface UserName {
    username: string
}
export interface MessageChangePasswordData {
    messageChangePassword: {
        phone: string
        message: string
    }
}
export interface ChangePasswordData {
    changePassword: {
        message: string
    }
}

export interface HeaderProps {
    title: string
    subtitle: string
}
export interface AnalyticsProps {
    event: string
    path?: string
    isTracked?: boolean
    steps?: string
    href?: string
    register_validation?: string
}

export interface StatusMessage {
    status: string
    message: string
}

export interface PersonalDataMDM {
    name?: string
    socialName?: string
    cpf?: string
    birthDate?: string
    term?: boolean
    phoneContacts?: Array<Contact>
    emailContacts?: Array<Contact>
}

export type TokenType = (number | null)[]
export interface LocationState {
    name?: string
    birthdate?: string
    isInvalid?: boolean
}
